import React from 'react'

import IconBase, { IconProps } from './IconBase'

const IconArrowTopRight = ({ size, className }: IconProps) => (
  <IconBase size={size} className={className}>
    <path
      d="m7.668 6.0248c0-0.41249 0.3344-0.74689 0.74689-0.74689h9.5603c0.41246 0 0.7469 0.3344 0.7469 0.74689v9.5603c0 0.41249-0.33444 0.7469-0.7469 0.7469s-0.7469-0.3344-0.7469-0.7469v-7.7571l-10.675 10.675c-0.29169 0.29159-0.76458 0.29159-1.0563 0-0.29167-0.29176-0.29167-0.76465 0-1.0564l10.675-10.675h-7.7571c-0.41249 0-0.74689-0.3344-0.74689-0.74689z"
      clipRule="evenodd"
      fillRule="evenodd"
      strokeWidth="1.7072"
    />
  </IconBase>
)

export default IconArrowTopRight
